import { memo, useEffect } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Typography, useMediaQuery } from "@mui/material";

// project imports
import menuItem from "@menuItems";
import NavGroup from "./NavGroup";
import useConfig from "@hooks/useConfig";
import useAuth from "@hooks/useAuth";
// import { DashboardMenu } from '@menuItems/dashboard';

import LAYOUT_CONST from "@constant";
import { HORIZONTAL_MAX_ITEM } from "@config";

const filterChildrenByRole = (group, role) => {
  const roleFilters = {
    isAdmin: {
      remove: ["rootadmin"],
      keep: [
        "staff-group",
        "mybusiness",
        "proposals",
        "projects",
        "tasks",
        "invoices",
        "expenses-group",
        "properties",
        "services",
        "accounts",
        "leads",
        "orders",
        "categories",
        "reports",
      ],
    },
    isStaff: {
      keep: [
        "proposals",
        "projects",
        "tasks",
        "invoices",
        "properties",
        "services",
        "leads",
        "orders",
        "categories",
      ],
      remove: [
        "staff-group",
        "mybusiness",
        "expenses-group",
        "accounts",
        "reports",
      ],
    },
    isSuperAdmin: {
      keep: ["rootadmin"],
      remove: [
        "staff-group",
        "mybusiness",
        "proposals",
        "projects",
        "tasks",
        "invoices",
        "expenses-group",
        "properties",
        "services",
        "accounts",
        "leads",
        "orders",
        "categories",
        "reports",
      ],
    },
  };

  const filter = roleFilters[role];

  return group.children.filter((child) => {
    if (filter.keep) {
      return filter.keep.includes(child.id);
    }
    if (filter.remove) {
      return !filter.remove.includes(child.id);
    }
    return true;
  });
};

const filterItemsByRole = (items, role) => {
  return items
    .map((group) => {
      const filteredChildren = filterChildrenByRole(group, role);
      const hasChildren = filteredChildren.length > 0;
      return {
        ...group,
        children: filteredChildren,
        ...(hasChildren ? {} : { children: null }),
      };
    })
    .filter((group) => group.children !== null); // Filtrar grupos sin hijos
};

const MenuList = () => {
  const theme = useTheme();
  const { layout } = useConfig();
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const { user } = useAuth();

  const isAdmin = user?.is_admin ?? false;
  const isStaff = user?.is_staff ?? false;
  const isSuperAdmin = user?.is_super_admin ?? false;

  // last menu-item to show in horizontal menu bar
  const lastItem =
    layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd
      ? HORIZONTAL_MAX_ITEM
      : null;
  console.log(menuItem);
  let lastItemIndex = menuItem.items.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < menuItem.items.length) {
    lastItemId = menuItem.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = menuItem.items
      .slice(lastItem - 1, menuItem.items.length)
      .map((item) => ({
        title: item.title,
        elements: item.children,
      }));
  }

  // Filtrar elementos basados en el tipo de usuario
  let filteredItems = menuItem.items;

  if (isAdmin) {
    filteredItems = filterItemsByRole(filteredItems, "isAdmin");
  }
  if (isSuperAdmin) {
    filteredItems = filterItemsByRole(filteredItems, "isSuperAdmin");
  }
  if (isStaff) {
    filteredItems = filterItemsByRole(filteredItems, "isStaff");
  }

  console.log("Filtered Menu Items:", filteredItems);

  const navItems = filteredItems.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case "group":
        return (
          <NavGroup
            key={item.id}
            item={item}
            lastItem={lastItem}
            remItems={remItems}
            lastItemId={lastItemId}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default memo(MenuList);
